module.exports = __webpack_public_path__ + "img/sq6m_01.21b58cc3.jpg";